@if (isDevEnvironment) {
  <div class="dev-banner"><span class="banner-emoji">🚧</span> DEV ENVIRONMENT — This is not the production site <span class="banner-emoji">🚧</span></div>
}
<div class="layout-wrapper" [class.has-dev-banner]="isDevEnvironment">
<mat-toolbar class="header">
  <mat-toolbar-row>
    <div class="header-logo">
      <a routerLink="/" routerLinkActive="active">
        <img src="../../assets/Landpoint_Logo_2022_Main_sm.png" alt="Your Logo" />
      </a>
    </div>
    <span class="spacer"></span>
    <div class="desktop-menu">
      <button mat-button routerLink="/" routerLinkActive="active">Home</button>
      <button mat-button routerLink="/human-resources" routerLinkActive="active">Human Resources</button>
      <button mat-button routerLink="/marketing" routerLinkActive="active">Marketing</button>
      <button mat-button routerLink="/safety" routerLinkActive="active">Safety</button>
      <button mat-button routerLink="/information-technology" routerLinkActive="active">IT</button>
      <button mat-button routerLink="/standards" routerLinkActive="active">Standards</button>
      <button mat-button routerLink="/weather" routerLinkActive="active">Weather</button>
      <button mat-button routerLink="/travel" routerLinkActive="active">Travel</button>
      <button mat-button routerLink="/learning" routerLinkActive="active">Training</button>
      @if (accessControl.hasAnyAdminAccess()) {
        <button mat-button routerLink="/admin" routerLinkActive="active" class="admin-nav-btn">Admin</button>
      }
    </div>
    <div class="mobile-menu">
      <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-icon">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item routerLink="/" routerLinkActive="active">Home</button>
        <button mat-menu-item routerLink="/safety" routerLinkActive="active">Safety</button>
        <button mat-menu-item routerLink="/information-technology" routerLinkActive="active">IT</button>
        <button mat-menu-item routerLink="/human-resources" routerLinkActive="active">HR</button>
        <button mat-menu-item routerLink="/marketing" routerLinkActive="active">Marketing</button>
        <button mat-menu-item routerLink="/standards" routerLinkActive="active">Standards</button>
        <button mat-menu-item routerLink="/weather" routerLinkActive="active">Weather</button>
        <button mat-menu-item routerLink="/travel" routerLinkActive="active">Travel</button>
        <button mat-menu-item routerLink="/learning" routerLinkActive="active">Training</button>
        @if (accessControl.hasAnyAdminAccess()) {
          <button mat-menu-item routerLink="/admin">Admin</button>
        }
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<div class="container">
  <router-outlet id="top"></router-outlet>
</div>
<br><br><br><br>
<mat-toolbar class="footer">
  <p>© Landpoint 2022</p>
</mat-toolbar>
</div>
